<mat-toolbar-row class="bg-white p-0 pr-3">
  <button class="ml-3 d-block d-lg-none align-middle" mat-button aria-label="LOA Status Color" matTooltip="LOA Status" [matMenuTriggerFor]="menu">
    <mat-icon inline fontSet="fas" fontIcon="fa-stream"></mat-icon>
    LOA Status
  </button>
  <div class="pl-3 d-none d-lg-block">
    <div class="d-flex justify-content-start">
      <div class="rounded p-3 mx-2 text-white bg-light" style="width: 5.5rem">
        <div class="d-flex justify-content-start text-dark font-weight-bolder">
          <span>Total:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-1">{{ status?.total || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-success" style="width: 6.5rem">
        <div class="d-flex justify-content-start font-weight-bolder">
          <span>Active:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.active || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-canceled" style="width: 7rem">
        <div class="d-flex justify-content-start text-dark font-weight-bolder">
          <span>Inactive:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.inActive || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-info" style="width: 7.5rem">
        <div class="d-flex justify-content-start font-weight-bolder">
          <span>Canceled:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.canceled || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-danger" style="width: 7rem">
        <div class="d-flex justify-content-start font-weight-bolder">
          <span>Expired:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.expired || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-warning-light" style="width: 10.9rem">
        <div class="d-flex justify-content-start text-dark font-weight-bolder">
          <span>Expire in 1 Week:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.expireInOneWeek || 0 }}</span>
        </div>
      </div>
      <div class="rounded p-3 mx-2 text-white bg-primary" style="width: 12.5rem">
        <div class="d-flex justify-content-start text-dark font-weight-bolder">
          <span>Expire in 2-4 Weeks:</span>
          <mat-spinner diameter="14" class="my-1 ml-1" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading" class="ml-2">{{ status?.expireInTwoFourWeeks || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
  <span class="filler"></span>
  <a mat-flat-button color="accent" aria-label="Sign New Contract" [routerLink]="['/home/third-party-providers/authorization']" *ngIf="!has3PLRole">
    Sign New Contract
  </a>
</mat-toolbar-row>

<mat-menu #menu="matMenu">
  <button mat-menu-item aria-label="Status Total">Totals: {{ status?.total || 0 }}</button>
  <button mat-menu-item aria-label="Status Active">Active: {{ status?.active || 0 }}</button>
  <button mat-menu-item aria-label="Status InActive">InActive: {{ status?.inActive || 0 }}</button>
  <button mat-menu-item aria-label="Status Canceled">Canceled: {{ status?.canceled || 0 }}</button>
  <button mat-menu-item aria-label="Status Expired">Expired: {{ status?.expired || 0 }}</button>
  <button mat-menu-item aria-label="Status Expired in One Week">Expire in 1 Week: {{ status?.expireInOneWeek || 0 }}</button>
  <button mat-menu-item aria-label="Status Expired in 2-4 Weeks">Expire in 2-4 Weeks: {{ status?.expireInTwoFourWeeks || 0 }}</button>
</mat-menu>
